<template>
  <b-modal
    ref="videoTourModal"
    id="videoTourModal"
    content-class="videoTourModal"
    size="xl"
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @hide="onClose"
    @show="onShow"
  >
  <template #modal-title>{{ isEdit ? $t("actions.edit") : $t("actions.add") }} video tour </template>
    <template>
      <validation-observer v-slot="{ handleSubmit }">
        <b-alert :show="showAlert" variant="warning" class="p-1">
          El video tour esta en proceso de validación.
        </b-alert>
        <b-form
          class="auth-login-form mt-2"
          @submit.prevent="handleSubmit(onSubmit)"
          ref="createVideoTour"
        >
        <b-row>
          <!-- NAME -->
          <b-col cols="3">
            <validation-provider
              name="name"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('video_tour.name')"
                label-for="name"
              >
                <b-form-input id="name" v-model="videoTourName" trim />
                <p v-if="errors" class="small text-danger">
                  {{ errors[0] }}
                </p>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- INTERVAL -->
          <b-col cols="3">
            <validation-provider
              name="interval"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('video_tour.time_interval')"
                label-for="token_lifetime"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button
                      variant="primary"
                      @click="videoTourInterval--"
                      :disabled="videoTourInterval <= 1 || videoTourInterval == null"
                      >-</b-button
                    >
                  </b-input-group-prepend>

                  <b-form-input
                    class="text-center"
                    type="number"
                    v-model="videoTourInterval"
                    min="1"
                  />

                  <b-input-group-append>
                    <b-button variant="primary" @click="videoTourInterval++"
                      >+</b-button
                    >
                  </b-input-group-append>
                  <p v-if="errors" class="small text-danger">
                    {{ errors[0] }}
                  </p>
                </b-input-group>
                <small class="form-text text-muted">
                  {{$t('video_tour.time_interval_description')}}
                </small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- TENANT -->
          <b-col cols="3">
            <validation-provider
              name="tenant"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-group
                class="text-capitalize"
                label="Tenant"
                label-for="tenant"
              >
                <v-select
                  v-model="currentTenantSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="tenantOptions"
                  class="w-100"
                  label="name"
                  input-id="id_tenant"
                  :clearable="false"
                  :getOptionKey="option => option.id"
                />
                <p v-if="errors" class="small text-danger">
                  {{ errors[0] }}
                </p>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="auto" class="d-flex align-items-center videoTourSaveBtn">
            <b-button
              v-if="showSubmitButton"
              variant="primary"
              class="mr-1 text-capitalize"
              type="submit"
            >
              <span v-if="!loadingSaveVideoTour">{{ isEdit ? `${$t("actions.edit")}` : `${$t("actions.add")}` }}</span>
              <b-spinner v-else small></b-spinner>
            </b-button>
            <b-button
              v-if="showSendToValidationButton"
              type="button"
              variant="primary"
              class="text-capitalize"
              @click="sendToValidation()"
            >
              <span v-if="!loadingSendToValidation">
                Mandar a revisión
              </span>
              <b-spinner v-else small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
        </b-form>
      </validation-observer>
    </template>
    <template>
      <div class="videoTour-view-preview-container text-center">
        <span class="">{{ $t('video_tour.preview') }}</span>
        <div class="d-flex align-items-center justify-content-center">
          <div class="w-50">
            <LayoutViews
              :key="currentPreviewSelected.updated_at"
              :view="currentPreviewSelected"
              :showMoveControls="false"
              :showAddControl="false"
              v-if="currentPreviewSelected"
            />
            <div class="videoTour-view-preview-message" v-else>
              {{ $t('video_tour.preview_message') }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template>
      <div class="videoTour-dual-list" style="margin-top: 100px;">
        <div class="videoTour-views-container pr-1">
          <div class="">
            <span class="font-weight-bold h5 videoTourDualListTitle">{{ $t('video_tour.views_list') }}</span>
            <b-input-group class="w-50 my-1">
              <b-input-group-prepend is-text>
                <i class="feather icon-search"></i>
              </b-input-group-prepend>

              <b-form-input
                id="searchView"
                v-model="viewsSearch"
                trim
                :placeholder="$t('search')"
                @input="onTypeSearch"
              />
            </b-input-group>
          </div>
          <div class="row">
            <div
              v-for="(view, index) in userViews"
              :key="index"
              class="col-4 mb-3"
              @click="addPreview(view)"
            >
              <LayoutViews
                :key="view.updated_at"
                :view="view"
                @addView="addView"
                :slot-height="18"
              />
            </div>
          </div>
          <PaginationWidgets
            :sidebarMinWidthReached="false"
            :per-page.sync="viewsPerPage"
            :current-page.sync="viewsCurrentPage"
            :total-records="userViewsTotalRecords"
            @update:currentPage="updateViewsCurrentPage"
            @update:perPage="updateViewsPerPage"
          />
        </div>
        <div class="videoTour-result-container">
          <div class="d-flex flex-column">
            <span class="mt-1 font-weight-bold h5 videoTourDualListTitle">{{ $t('video_tour.selected_views') }}</span>
            <span class="viewsSelectedCount">{{viewsSelected.length}} {{ $t('video_tour.items_selected') }}</span>
          </div>
          <div v-if="currentItemToEdit && isLoadingSelectedViews" class="">
            <div  class="d-flex flex-wrap justify-content-between">
              <SkeletonLoading
                v-for="(load, index) in 4"
                :key="index+'skeleton'"
                class="videoTour-view-item"
                :width="140"
                :height="120"
              />
            </div>
          </div>
           <div v-else class="row">
              <div
                v-for="(view, index) in viewsSelected"
                :key="index"
                class="col-4 mb-3">
                <LayoutViews
                  :key="view.updated_at"
                  :view="view"
                  :showMoveControls="true"
                  :showAddControl="false"
                  :slot-height="18"
                  @removeView="removeView"
                  @moveView="moveView"
                />
              </div>
            </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { useVideoTour } from '@/composables/videoTour'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow, BCol,BSpinner
} from 'bootstrap-vue'
import LayoutViews from "./LayoutViews";
import PaginationWidgets from "../components/PaginationWidgets.vue";
import vSelect from "vue-select";
import SkeletonLoading from "@/components/SkeletonLoading.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    LayoutViews,
    BSpinner,
    PaginationWidgets,
    vSelect,
    SkeletonLoading
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    currentItemToEdit: {
      type: Object,
      default: {},
    },
  },
  setup(props, { emit }) {
    const {
      videoTourName,
      videoTourInterval,
      userViews,
      viewsSelected,
      currentPreviewSelected,
      loadingSaveVideoTour,
      viewsPerPage,
      viewsCurrentPage,
      userViewsTotalRecords,
      viewsSearch,
      onTypeSearch,
      tenantOptions,
      currentTenantSelected,
      isLoadingSelectedViews,
      addView,
      removeView,
      addPreview,
      onClose,
      moveView,
      onSubmit,
      loadDataOnEdit,
      getUserViews,
      updateViewsCurrentPage,
      updateViewsPerPage,
      showSendToValidationButton,
      loadingSendToValidation,
      sendToValidation,
      showSubmitButton,
      videoToursValidation,
      showAlert
    } = useVideoTour(props.isEdit)

    function onShow() {
      showSendToValidationButton.value = false;
      getUserViews();
      if(props.isEdit) {
        loadDataOnEdit(props.currentItemToEdit)
      }
    }

    return {
      videoTourName,
      videoTourInterval,
      userViews,
      viewsSelected,
      currentPreviewSelected,
      loadingSaveVideoTour,
      viewsPerPage,
      viewsCurrentPage,
      userViewsTotalRecords,
      viewsSearch,
      onTypeSearch,
      tenantOptions,
      currentTenantSelected,
      isLoadingSelectedViews,
      addView,
      removeView,
      addPreview,
      onClose,
      moveView,
      onSubmit,
      updateViewsCurrentPage,
      updateViewsPerPage,
      onShow,
      showSendToValidationButton,
      loadingSendToValidation,
      sendToValidation,
      showSubmitButton,
      videoToursValidation,
      showAlert
    }
  },
}
</script>
